<template>
  <form @submit.prevent="save">
    <!-- Error -->
    <div v-if="('general' in errors)" class="mb-md">
      <p class="has-text-danger">{{ errors.general }}</p>
    </div>
    <div class="columns">
      <div class="column">
        <div class="has-background-white rounded-lg">
          <div class="mb-sm">
            <p class="has-text-weight-bold">{{ title }}</p>
            <p class="is-size-7 has-text-grey">{{ text }}</p>
          </div>
          <div class="columns is-vcentered is-mobile">
            <!-- fields -->
            <div class="column">
              <b-field>
                <b-input
                  type="email"
                  placeholder="Email address or distribution list..."
                  v-model="emailAddress"
                  :disabled="enabled === 'Enabled'"
                  @input="isDirty = 1"
                ></b-input>
              </b-field>
              <b-field>
                  <b-switch
                    v-model="enabled"
                    true-value="Enabled"
                    false-value="Not Enabled"
                    type="is-success"
                    :disabled="!emailAddress"
                    @input="save">
                    {{ enabled }}
                  </b-switch>
                </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {

  },
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      const base = this.context.route + `/${this.notificationType}/`
      return (this.notification !== null)
        ? base + this.notification.id + '/'
        : base
    },
    method () {
      return (this.notification !== null) ? 'patch' : 'post'
    },
    json () {
      const json = {
        recipient_email: this.emailAddress,
        status: (this.enabled === 'Enabled') ? 'enabled' : 'disabled'
      }
      if (this.notificationType === 'notifications') {
        json.crontab = '0 2 * * *'
        json.type = { name: this.action }
      } else {
        json.action = { name: this.action }
        json.name = this.action
        json.delivery_method = 'recipient'
      }
      return json
    },
    ready () {
      return (this.value !== null)
    }
  },
  data () {
    return {
      isDirty: false,
      notification: null,
      enabled: 'Not Enabled',
      emailAddress: null,
      errors: {},
      saving: false
    }
  },
  methods: {
    save () {
      this.saving = true
      this.$http[this.method](this.endpoint, this.json).then(response => {
        this.notification = response.data
        this.isDirty = false
        this.$buefy.toast.open({ type: 'is-success', message: 'Preference updated!' })
      }).catch(error => {
        if (error.response && error.response.status === 400) {
          this.errors = error.response.data
          this.enabled = 'Not Enabled'
        }
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please review your input and try again.' })
      }).finally(() => {
        this.saving = false
      })
    }
  },
  mounted () {
    const notification = this.$utils.find(this.notifications, (notification) => {
      if (this.notificationType === 'notifications') {
        return notification.type && notification.type.name === this.action
      } else {
        return notification.action && notification.action.name === this.action
      }
    })
    if (typeof notification !== 'undefined') {
      this.notification = notification
      this.emailAddress = notification.recipient_email
      this.enabled = (notification.status === 'enabled') ? 'Enabled' : 'Not Enabled'
    }
  },
  props: {
    notifications: {
      type: Array,
      required: true
    },
    action: {
      type: String
    },
    title: {
      type: String
    },
    text: {
      type: String
    },
    page: {
      type: String,
      enum: ['onboarding', 'settings'],
      default: 'settings'
    },
    notificationType: {
      type: String,
      enum: ['notifications', 'push-notifications'],
      default: 'push-notifications'
    }
  }
}
</script>
